import { LOCATIONS_ACTION_TYPES } from 'store/actions/locations.actions';

const initialState = {
  isLoadingCountries: false,
  countries: [],
  isLoadingCities: false,
  cities: {},
};

export default function(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {

    case LOCATIONS_ACTION_TYPES.LOAD_COUNTRIES:
      return {
        ...state,
        isLoadingCountries: true,
      };

    case LOCATIONS_ACTION_TYPES.SUCCESS_COUNTRIES:
      return {
        ...state,
        countries: payload,
        isLoadingCountries: false,
      };

    case LOCATIONS_ACTION_TYPES.LOAD_CITIES:
      return {
        ...state,
        isLoadingCities: true,
      };

    case LOCATIONS_ACTION_TYPES.SUCCESS_CITIES:
      return {
        ...state,
        cities: { ...state.cities, ...payload },
        isLoadingCities: false,
      };

    default:
      return state;
  }
}